import { httpServices } from '@libs/data-access/queries'

import type { QueryFnParams } from '../../../types'

import type { ScheduleMembershipSchema } from './scheduleMembershipService'

export type FetchScheduleMembershipOptions = QueryFnParams<{
  pathParams: {
    membership_id: number
  }
}>

export const fetchScheduleMembershipById = async (
  opts: FetchScheduleMembershipOptions
) => {
  const response = await httpServices.core.get<ScheduleMembershipSchema>(
    `/planning/memberships/${opts.pathParams.membership_id}`
  )

  return response.data
}
